import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)
import Router from 'vue-router'
import Meta from 'vue-meta'

import {i18n} from '@/plugins/i18n.js'


import App from '@/App'

// Layouts
// import Adminlayout from '@/layouts/Adminlayout'
import Generic from '@/layouts/Generic'
import Landing from '@/layouts/Landing'

// Pages
import AdminPage from '@/pages/AdminPage';
import AdminHome from '@/pages/AdminHome';
import AdminLeads from '@/pages/AdminLeads';
import AdminSettings from '@/pages/AdminSettings';
import ResultPrint from '@/pages/ResultPrint'
import AdminCreate from '@/pages/AdminCreate';
import SurveyStart from '@/pages/SurveyStart';
import SurveyQuestion from '@/pages/SurveyQuestion';
import SurveyAdditionalInfo from '@/pages/SurveyAdditionalInfo';
import ResultsWeb from '@/pages/ResultsWeb';
import RedirectPDF from '@/pages/RedirectPDF';

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/administrator',
      component: {
        template: "<router-view></router-view>"
      },
      children: [
      {
        path: '',
        name: 'Admin Home',
        component: AdminHome,
        meta: {layout: "adminlayout"}
      },
      {
        path: 'leads',
        name: 'Admin Leads',
        component: AdminLeads,
        meta: {layout: "adminlayout"}
      },
      {
        path: 'survey',
        name: 'Admin Survey',
        component: AdminPage,
        meta: {layout: "adminlayout"}
      },
      {
        path: 'survey/create',
        name: 'Create Survey',
        component: AdminCreate,
        meta: {layout: "adminlayout"}
      },
      {
        path: 'survey/edit/:id',
        name: 'Edit Survey',
        component: AdminCreate,
        meta: {layout: "adminlayout"}
      },
      {
        path: 'settings',
        name: 'Admin Settings',
        component: AdminSettings,
        meta: {layout: "adminlayout"}
      }]
    },
    {
      path: '/:lang?/',
      component: {
        template: "<router-view></router-view>"
      },
      children: [
      {
        path: '', // en,
        name: 'Start Survey',
        component: SurveyStart,
        meta: {layout: "landing"}
      },
      {
        path: 'questions/:pageNumber',
        name: 'Survey questions',
        component: SurveyQuestion,
        meta: {layout: "survey"}
      },
      {
        path: 'vos_informations',
        name: 'Additional Information',
        component: SurveyAdditionalInfo,
        meta: {layout: "generic"}
      },
      {
        path: 'resultats/:id',
        name: 'resultats',
        component: ResultsWeb,
        meta: {layout: "generic"}
      },
      {
        path: 'render/:id',
        name: 'PDF results',
        component: ResultPrint,
        meta: {layout: "print"}
      }
      ],
      beforeEnter (to, from, next) {
        console.log("Lang selection")
        // use the language from the routing param or default language
        let language = to.params.lang;
        console.log("Lang selection : ", language)
        if (!language || !['en','fr'].includes(language)) {
          return next('fr/');
        }
        // set the current language for vuex-i18n. note that translation data
        // for the language might need to be loaded first
        i18n.locale = language
        console.log("Lang selection i18n: ", i18n.locale)
        // Render the page
        next();
      },

    },
    {
      path: '/render/:id',
      component: ResultPrint,
      meta: {layout: "print"}
    },
    {
      path: '/pdf/:id',
      component: RedirectPDF,
      meta: {layout: "print"}
    },
    // {
    //   path: '/old_home_deprecated',
    //   component: App
    // },
  ],
});

router.onReady(() => {

  // Load the main script from GA
  var tracking_id = "UA-XXXXXX-2";
  var url = "https://www.googletagmanager.com/gtag/js?id=" + tracking_id;
  var script = document.createElement("script");  // create a script DOM node
  script.src = url;  // set its src to the provided URL
  document.head.appendChild(script);  // add it to the end of the head section of the page (could change 'head' to 'body' to add it to the end of the body section instead)

  // Now let's synchronize the script data
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  // GA configuration
  if (process.env.NODE_ENV === 'development') {
    gtag('config', tracking_id, { 'send_page_view': false });
  }

  let language = (router.currentRoute.params.lang).toUpperCase();
  let question_nb = (typeof router.currentRoute.params.pageNumber === 'undefined') ? "" : " " + router.currentRoute.params.pageNumber;

  // Send a pageview
  gtag('config', tracking_id, {
    'page_title' : language + " - " + router.currentRoute.name + question_nb,
    'page_path': router.currentRoute.path
  });


  router.afterEach(( to, from ) => {

    let language = (to.params.lang).toUpperCase();
    let question_nb = (typeof to.params.pageNumber === 'undefined') ? "" : " " + to.params.pageNumber;

    // Send correct page view to GA (even with segments)
    gtag('config', tracking_id, {
      'page_title' : language + " - " + to.name + question_nb,
      'page_path': to.fullPath
    });

    // Send GTM conversion event

    if (to.name==="Survey questions" && from.name==="Start Survey") {
      gtag('event', 'surveyStarted');
    }
    if (to.name==="resultats" && from.name==="Additional Information") {
      gtag('event', 'surveyCompleted');
    }

  });
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js